// Decides when the SPA entry may call ReactDOM.render.
//
// Healthy path: wait for DOMContentLoaded, as the entry always has.
//
// Rescue path (assetRescueWatchdog.inline.js set __m8AssetRescueActivated):
// DOMContentLoaded is useless in both directions — the stalled CDN defer
// scripts delay it for minutes, or it already fired before the rescued copy
// executed. But rendering immediately is not safe either: rescue-injected
// scripts (async=false) execute as soon as they are downloaded, without
// waiting for the parser, and on the sticky path (arm delay 0 + HTTP-cached
// GCS copies) the entry can run before <div id="root"> is parsed. Rendering
// into a null root throws AFTER claimPackExecution consumed the claim, so
// the late CDN copy no-ops too — a permanently blank page, the exact failure
// the watchdog exists to prevent.
//
// So on the rescue path we gate on document.readyState instead: 'interactive'
// fires when parsing finishes, BEFORE deferred scripts execute, so unlike
// DOMContentLoaded it cannot be stalled by the dead CDN defer tags.
export const scheduleSpaBoot = (boot, { rescued, doc = document } = {}) => {
  if (!rescued) {
    // The entry ships as a defer script, so readyState is 'loading' here in
    // production; the guard keeps the boot from being silently swallowed if
    // this ever runs after DOMContentLoaded (dynamic injection, test harness).
    if (doc.readyState !== 'loading') {
      boot();
      return;
    }
    doc.addEventListener('DOMContentLoaded', () => boot());
    return;
  }

  if (doc.readyState !== 'loading') {
    boot();
    return;
  }

  const onReadyStateChange = () => {
    if (doc.readyState === 'loading') return;
    doc.removeEventListener('readystatechange', onReadyStateChange);
    boot();
  };
  doc.addEventListener('readystatechange', onReadyStateChange);
};

export default scheduleSpaBoot;
